
import {Notification} from "element-ui";
import {DB} from "../../../../firebase/db";
import {mapGetters} from "vuex";
import {Storage} from "../../../../firebase/storage";
import {axios} from '../../../../bootstrap';

const ChatSetupController = {
    firestore() {
        return {
            applications: this.fetchApplications(),
        }
    },

    data() {
        return {
            form: {
                name: '',
                hostname: '',
                prechat: false,
                prechat_message: '',
                color: '#409EFF',
                delayed_time: '10',
                postchat: false,
                post_chat_message: '',
                show_agent_profile: true,
                trigger: false,
                url: '',
                show_feedback: false,
                customer_account: ''
            },
            applications: [],
            step: 'webchat',
            subscribing: false,
            sending: false,
            drawer: false,
            imageData: null,
            picture: null,
            uploadValue: 0,
            uploading: false
        }
    },

    computed: {
        ...mapGetters({
            apps: 'getProducts',
            project: 'getProject',
        }),

        account() {
            return null;
        },

        application() {
            return this.applications.length > 0 ? this.applications[0] : {};
        },
    },
    mounted() {
        this.$store.dispatch('getProducts').then(() => {
            // Do nothing
        })
    },

    watch: {
        application: {
            handler: function () {
                this.form.name = this.application.name;
                this.form.hostname = this.application.hostname;
                this.form.customer_account = this.application.customer_account;
                this.form.color = this.application.color;
                this.form.show_agent_profile = this.application.show_agent_profile;
                this.form.url = this.application.url === undefined ? '' : this.application.url;
            }, immediate: true
        },
    },

    methods: {
        subscribe() {
            this.subscribing = true;
            axios.post(`projects/${this.project.id}/products/activate/${this.$route.params.product}`, {

            });
        },

        submitWebChat() {

            this.form.project_id = this.project.id;
            this.form.customer_account = parseInt(this.form.customer_account);
            this.form.app_id = this.random() + this.random();

            if(this.form.name === undefined && this.form.hostname === undefined) {

                Notification.warning({ title: 'Warning!', message: 'Fill the form then proceed' });

                return ;
            }

            if(this.application && this.application.id) {
                this.sending = true;

                DB.collection('applications').doc(this.application.id)
                    .set(this.form, { merge: true })
                    .then( () => {
                        this.sending = false;

                        Notification.success({ title: 'Success', message: 'Application updated successfully!', position: 'bottom-right'});

                    }, () => {
                        this.sending = false;
                        Notification.error({ title: 'Error!', message: 'An error occurred, please try again later!', position: 'bottom-right' });
                    });
            } else {
                this.sending = true;
                DB.collection('applications').add(this.form)
                    .then( () => {
                        this.sending = false;

                        Notification.success({ title: 'Success', message: 'Application added successfully!', position: 'bottom-right'});

                    }, () => {
                        this.sending = false;
                        Notification.error({ title: 'Error!', message: 'An error occurred, please try again later!', position: 'bottom-right' });
                    });
            }
        },


        onUpload(){

            this.uploading = true;

            this.picture = null;

            this.uploadedData = event.target.files[0];

            let storageRef = Storage.ref(`chatuploads/${this.type}s/${this.uploadedData.name}`).put(this.uploadedData);

            storageRef.on(`state_changed`, snapshot=> {
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            }, error => {}, ()=> {

                this.uploadValue = 100;

                storageRef.snapshot.ref.getDownloadURL().then((url) => {
                    DB.collection('applications')
                        .doc(this.application.id)
                        .set({
                            url: url
                        }, { merge: true });

                });

                this.uploading = false;
            });
        },

        random() {
            return Math.random().toString(36).substr(5);
        },

        fetchApplications() {
            if(this.project) {
                return DB.collection('applications')
                    .where('project_id', '==', this.$route.params.project);
            }

            return [];
        },

        next(view) {
            this.step = view;
        },

        back(view) {
            this.step = view;
        },
    }
};

export default ChatSetupController;
